/* -------------------------------------------------------------------------- */
/*                              ANCHOR GLOSARIO                               */
/* -------------------------------------------------------------------------- */

/** Terminos del documento de referencia "Glosario Zorro Abarrotero". */
export const GLOSARIO: Array<{ termino: string; definicion: string }> = [
  {
    termino: 'NPS',
    definicion:
      'Net Promoter Score. Indicador de lealtad que resulta de restar el porcentaje de detractores al porcentaje de promotores; se expresa en puntos, de -100 a 100.',
  },
  {
    termino: 'Promotor',
    definicion:
      'Cliente que califica la recomendación con 9 o 10. Es leal, repite compra y recomienda la tienda de forma espontánea.',
  },
  {
    termino: 'Pasivo',
    definicion:
      'Cliente que califica con 7 u 8. Está satisfecho pero no comprometido; no suma al NPS y puede migrar a la competencia.',
  },
  {
    termino: 'Detractor',
    definicion:
      'Cliente que califica de 0 a 6. Tuvo una mala experiencia y puede difundirla; resta directamente al NPS y detona una alerta.',
  },
  {
    termino: 'CSAT',
    definicion:
      'Customer Satisfaction Score. Porcentaje de clientes satisfechos con un atributo puntual del servicio, como precios, cremería o frutas y verduras.',
  },
  {
    termino: 'Palanca',
    definicion:
      'Tema de negocio al que se agrupan los comentarios abiertos, por ejemplo Protocolos de atención a cliente o Percepción de los precios.',
  },
  {
    termino: 'Driver de recomendación',
    definicion:
      'Motivo declarado por el cliente para recomendar o no la tienda. Explica el porqué de la calificación y ordena las prioridades de mejora.',
  },
  {
    termino: 'Close The Loop',
    definicion:
      'Cierre del ciclo: proceso de contactar al detractor tras su respuesta para resolver su queja y documentar el desenlace.',
  },
  {
    termino: 'Alerta',
    definicion:
      'Aviso automático que genera una encuesta con calificación de detractor y que debe atenderse dentro del tiempo comprometido.',
  },
  {
    termino: 'Plan de acción',
    definicion:
      'Compromiso documentado por el responsable de la sucursal para corregir la causa raíz de un detractor, con fecha compromiso y seguimiento.',
  },
  {
    termino: 'YTD',
    definicion:
      'Year To Date. Acumulado del año en curso, del 1 de enero a la fecha de corte del reporte.',
  },
  {
    termino: 'Rolling',
    definicion:
      'Ventana móvil de los últimos 12 meses. Se recorre mes a mes y suaviza la estacionalidad del indicador.',
  },
  {
    termino: 'Neto',
    definicion:
      'Resultado neto del NPS de un corte específico (sucursal, región o segmento): promotores menos detractores.',
  },
  {
    termino: 'Tasa de respuesta',
    definicion:
      'Porcentaje de encuestas contestadas respecto de las enviadas. Mide qué tan efectiva es la invitación al cliente.',
  },
  {
    termino: 'Comerciante',
    definicion:
      'Cliente que compra en la tienda para revender en su propio negocio. Se mide por separado del consumidor final.',
  },
  {
    termino: 'Consumidor final',
    definicion:
      'Cliente que compra para consumo propio o de su hogar, sin fines de reventa.',
  },
  {
    termino: 'Higienización de registros',
    definicion:
      'Depuración de la base de contactos: se eliminan duplicados, datos incompletos y correos o teléfonos inválidos antes del envío.',
  },
  {
    termino: 'Rebote',
    definicion:
      'Envío que no llegó al destinatario porque el correo o el número no existe o está bloqueado.',
  },
  {
    termino: 'Tasa de apertura',
    definicion:
      'Porcentaje de invitaciones entregadas que el cliente abrió. Indica el atractivo del asunto y del canal usado.',
  },
  {
    termino: 'Encuesta efectiva',
    definicion:
      'Encuesta abierta y completada con respuestas válidas. Es la única que alimenta el cálculo del NPS.',
  },
];
